import React from 'react';

import { TextField, TextFieldProps, InputAdornment } from '@mui/material';
import { FormikProps } from 'formik';

type Props = {
  fieldName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikProps<any>;
  isCurrency?: boolean;
} & TextFieldProps;

const FormikTextField: React.FC<Props> = ({
  fieldName,
  formik,
  isCurrency = false,
  ...props
}) => {
  return (
    <>
      {isCurrency ? (
        <TextField
          {...props}
          id={fieldName}
          name={fieldName}
          value={formik.values[fieldName]}
          onChange={formik.handleChange}
          error={formik.touched[fieldName] && Boolean(formik.errors[fieldName])}
          helperText={formik.touched[fieldName] && formik.errors[fieldName]}
          InputProps={{
            startAdornment: <InputAdornment position='start'>$</InputAdornment>,
          }}
        />
      ) : (
        <TextField
          {...props}
          id={fieldName}
          name={fieldName}
          value={formik.values[fieldName]}
          onChange={formik.handleChange}
          error={formik.touched[fieldName] && Boolean(formik.errors[fieldName])}
          helperText={formik.touched[fieldName] && formik.errors[fieldName]}
        />
      )}
    </>
  );
};

export default FormikTextField;
